import { render, staticRenderFns } from "./AppuntamentiOggi.vue?vue&type=template&id=6ca7e290"
import script from "./AppuntamentiOggi.vue?vue&type=script&lang=js"
export * from "./AppuntamentiOggi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports